import { render, staticRenderFns } from "./PaymentGateways.vue?vue&type=template&id=669c8de4"
import script from "./PaymentGateways.vue?vue&type=script&lang=js"
export * from "./PaymentGateways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports